export default __webpack_public_path__ + "static/media/sethETH.2cb05cd4.svg";